import { useState, useEffect } from 'react';

interface EventTargetObject {
  type: string;
  payload: {
    width: number
    height: number
    rect: DOMRect
  }
}
type FrameSizeEvent = MessageEvent<EventTargetObject>;

const EVENT_TYPE = 'GET_WINDOW_SIZE';

// Returns height, width & bounding rect from message payload
// (message is sent by WEB-DB iframe)
function useIframeSize(targetIframe: HTMLIFrameElement) {
  const [height, setHeight] = useState<number>(0);
  const [width, setWidth] = useState<number>(0);
  const [rect, setRect] = useState<DOMRect>();

  useEffect(() => {
    const handleMessage = (ev: FrameSizeEvent) => {
      if (!ev?.data?.type) return;
      if (ev.data.type !== EVENT_TYPE) return;
      if (!ev.data?.payload) return;
      if (targetIframe && ev.source !== targetIframe.contentWindow) return;

      setHeight(ev.data.payload.height);
      setWidth(ev.data.payload.width);
      setRect(ev.data.payload.rect);
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [targetIframe]);

  useEffect(() => {
    setRect(rect);
  }, [rect]);

  useEffect(() => {
    setHeight(height);
  }, [height]);

  useEffect(() => {
    setWidth(width);
  }, [width]);

  return { height, width, rect };
}

export default useIframeSize;
